export default __webpack_public_path__ + "static/media/SummariseBtn.3c0c7f9f.svg";